import { gql } from "@apollo/client"

export interface TerminalInput {
  id: number | string
}

export const ADD_TERMINALS_TO_GROUP = gql`
  mutation addTerminalsToGroup($organizationId: ID!, $organizationGroupId: ID!, $terminalIds: [TerminalInput]!) {
    addTerminalsToGroup(
      organizationGroupId: $organizationGroupId
      organizationId: $organizationId
      terminalIds: $terminalIds
    ) {
      updatedGroup {
        id
      }
    }
  }
`
